import RangeSlider from './range-slider'

export const AmuiRangeSlider = RangeSlider

export default Vue => Vue.component(RangeSlider.name, RangeSlider)
